var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "61.033%",
    y1: "4.965%",
    x2: "26.515%",
    y2: "71.91%",
    id: "366kpo8roc"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1FF",
    offset: ".657%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00BEFF",
    offset: "26.01%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D2FF",
    offset: "51.22%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DFFF",
    offset: "76.04%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E3FF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "107.589%",
    y1: "49.995%",
    x2: "-130.474%",
    y2: "49.995%",
    id: "r995q3fzpd"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFBD00",
    offset: "40.87%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "orange",
    offset: "77.54%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9C00",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "86.244%",
    y1: "30.9%",
    x2: "-50.144%",
    y2: "136.017%",
    id: "t5mxpbasce"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C31162",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-18.809%",
    y1: "-11.866%",
    x2: "42.093%",
    y2: "35.072%",
    id: "fs4zyozo7f"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2DA771",
    offset: "6.85%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15CF74",
    offset: "47.62%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#06E775",
    offset: "80.09%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F076",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-26.6%",
    y: "-29.7%",
    width: "159.4%",
    height: "159.4%",
    filterUnits: "objectBoundingBox",
    id: "k0xcrjmuca"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.647058824 0 0 0 0 0.678431373 0 0 0 0 0.741176471 0 0 0 0.7 0",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "xchukx8nkb",
    cx: 16,
    cy: 16,
    r: 16
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(5 6)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#k0xcrjmuca)",
    xlinkHref: "#xchukx8nkb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#xchukx8nkb"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.407.297C.19.527.06.883.06 1.345v16.509c0 .462.129.819.346 1.048l.056.054L9.71 9.709V9.49L.461.243.407.297z",
    fill: "url(#366kpo8roc)",
    transform: "translate(13.8 12.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.792 12.793 9.71 9.71v-.218l3.083-3.083.07.04 3.652 2.074c1.043.593 1.043 1.562 0 2.156l-3.652 2.075-.071.04z",
    fill: "url(#r995q3fzpd)",
    transform: "translate(13.8 12.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.863 12.753 9.71 9.6.407 18.903c.344.365.912.41 1.551.046l10.905-6.196z",
    fill: "url(#t5mxpbasce)",
    transform: "translate(13.8 12.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.863 6.447 1.958.251C1.32-.112.751-.067.407.297L9.71 9.6l3.153-3.153z",
    fill: "url(#fs4zyozo7f)",
    transform: "translate(13.8 12.4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.593 25.084 15.758 31.24c-.606.345-1.147.322-1.495.008l-.056.055.056.054c.348.313.889.337 1.495-.008l10.905-6.196-.07-.069z",
    fill: "#000",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.207 31.194c-.217-.23-.346-.587-.346-1.048v.109c0 .462.129.82.346 1.048l.056-.055-.056-.054zM30.315 22.969l-3.722 2.115.07.07 3.652-2.075c.521-.297.782-.687.782-1.078-.043.352-.31.7-.782.968z",
    fill: "#000",
    opacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.758 12.76 14.557 8.271c.474.269.739.616.782.969 0-.39-.26-.781-.782-1.078l-14.557-8.27c-1.044-.593-1.897-.101-1.897 1.094v.11c0-1.196.853-1.688 1.897-1.096z",
    fill: "#FFF",
    opacity: 0.25
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.bee6469d18acf034bdecc0a96d04b8e6.svg";
export { ForwardRef as ReactComponent };